import { combineReducers } from 'redux';

const defaultSearchedNumbers = {
  tnResult: [],
};
const searchedNumbers = (state = defaultSearchedNumbers, action) => {
  switch (action.type) {
    case 'SEARCH_NUMBER_SUCCESS':
      return action.searchedNumbers;
    case 'CLEAR_SEARCH_NUMBER':
      return defaultSearchedNumbers;
    default:
      return state;
  }
};

const defaultGateways = [];
const gateways = (state = defaultGateways, action) => {
  switch (action.type) {
    case 'GET_GATEWAYS_SUCCESS': {
      return action.gateways;
    }
    default:
      return state;
  }
};

const defaultQueryLrn = [];
const queryLrn = (state = defaultQueryLrn, action) => {
  switch (action.type) {
    case 'QUERY_LRN_SUCCESS':
      return action.queryLrn;
    case 'CLEAR_QUERY_LRN_MODAL':
      return defaultQueryLrn;
    default:
      return state;
  }
};

const defaultE911 = [];
const e911 = (state = defaultE911, action) => {
  switch (action.type) {
    case 'GET_E911_SUCCESS':
      return action.e911;
    default:
      return state;
  }
};

const defaultAddress = [];
const address = (state = defaultAddress, action) => {
  switch (action.type) {
    case 'GET_ADDRESS_SUCCESS':
      return action.address;
    case 'CLEAR_ADDRESS':
      return defaultAddress;
    default:
      return state;
  }
};
const defaultTrunkGroupList = {}
const trunkGroupList = (state = defaultTrunkGroupList, action) => {
  switch (action.type) {
    case 'GET_TRUNK_GROUP_LIST_SUCCESS':
      var { default: defaultValue, trunkGroupList } = action.data || {};
      if (!Array.isArray(trunkGroupList)) trunkGroupList = [];
      var find = trunkGroupList.find(group => group.trunkGroupName == defaultValue);
      if (!find) trunkGroupList = [...trunkGroupList, { trunkGroupName: defaultValue }];
      return { defaultValue, trunkGroupList };
    case 'GET_TRUNK_GROUP_LIST_ERROR':
      return defaultAddress;
    default:
      return state;
  }
};
export default combineReducers({
  searchedNumbers,
  gateways,
  e911,
  address,
  queryLrn,
  trunkGroupList
});
